<template>
  <div>
    <vxe-grid
      ref="inventoryTable"
      border
      auto-resize
      highlight-hover-row
      :tree-config="treeConfig"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{ seqMethod }"
      resizable
      show-footer
      :footer-method="footerMethod"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      treeConfig: {
        transform: true,
        rowField: 'orderDate',
        parentField: 'parentId',
        lazy: true,
        hasChild: 'hasChild',
        loadMethod: this.loadChildDate,
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      if (!this.tableData) return []
      if (this.tableData.length <= 0) return []
      const sumData = this.tableData[0].sumData
      let footerRow = [
        this.$l('INDEX.total') || '合计',
        '',
        '',
        '',
        '',
        '',
        '',
        sumData.quantity,
        '',
        sumData.productSalesCNY,
        sumData.productSalesUSD,
        sumData.productSales,
        '',
        '',
        sumData.volume,
      ]
      return [footerRow]
    },
  },

  methods: {
    async loadChildDate({ row }) {
      const {
        orderDate,
        storeCode,
        type,
        regionCode,
        amzSkuNo,
        beginDate,
        endDate,
      } = row || {}

      const res = await this.$api
        .orderboardChildListApi({
          storeCode,
          type,
          regionCode,
          amzSkuNo,
          beginDate,
          endDate,
        })
        .catch(() => null)
      if (!res) return []

      const data = res.body.data || []
      return data.map((item) => {
        return {
          ...item,
          rowId: row['rowId'],
          parentId: orderDate,
          hasChild: false,
        }
      })
    },
    seqMethod({ row, rowIndex }) {
      const seq = (this.tablePage.curPage - 1) * this.tablePage.pageSize
      if (!row['hasChild']) return row['rowId'] + '.' + (rowIndex + 1)
      row['rowId'] = seq + rowIndex + 1
      return row['rowId']
    },
    footerMethod() {
      return this.footerData
    },
  },
}
</script>
